import { render } from "./main.vue?vue&type=template&id=19dc661b&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"

import "./main.vue?vue&type=style&index=0&id=19dc661b&lang=less&scoped=true"
/* hot reload */
if (module.hot) {
  script.__hmrId = "19dc661b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19dc661b', script)) {
    api.reload('19dc661b', script)
  }
  
  module.hot.accept("./main.vue?vue&type=template&id=19dc661b&scoped=true", () => {
    api.rerender('19dc661b', render)
  })

}


import exportComponent from "D:\\develop\\simo\\front\\website\\front-bc-huibentong-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19dc661b"],['__file',"src/views/index/pages/main.vue"]])